module.exports = __webpack_public_path__ + "static/media/background-right.5ff338af.svg";